#import "../fragments/market-for-lead-fragment.graphql"

query GetMarketForLead($leadId: ID!) {
    lead(id: $leadId) {
        ...MarketForLeadFragment
    }
}
